import { render, staticRenderFns } from "./PostsList.vue?vue&type=template&id=76b1d280&scoped=true&lang=pug&"
import script from "./PostsList.vue?vue&type=script&lang=js&"
export * from "./PostsList.vue?vue&type=script&lang=js&"
import style0 from "./PostsList.vue?vue&type=style&index=0&id=76b1d280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b1d280",
  null
  
)

export default component.exports